import { render, staticRenderFns } from "./Map-6-cities.vue?vue&type=template&id=3547c3d9&"
import script from "./Map-6-cities.vue?vue&type=script&lang=js&"
export * from "./Map-6-cities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports